import { render, staticRenderFns } from "./ComToComPayInfo.vue?vue&type=template&id=4029b632&scoped=true&"
import script from "./ComToComPayInfo.vue?vue&type=script&lang=js&"
export * from "./ComToComPayInfo.vue?vue&type=script&lang=js&"
import style0 from "./ComToComPayInfo.vue?vue&type=style&index=0&id=4029b632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4029b632",
  null
  
)

export default component.exports